import { Grid, Space, Title } from "@mantine/core";

export const Logo = () => {
  return (
    <div>
      <Space mt={24} />
      <Grid>
        <img
          height={35}
          src="./xmaillogo.svg"
          alt=""
          style={{ marginLeft: 5 }}
        />
        <Title
          className="no_select"
          style={{
            fontWeight: 500,
            cursor: "default",
            letterSpacing: "1px",
          }}
          order={3}
          ml={18}
          align="left"
          mt={3}
        >
          X-MAIL
        </Title>
      </Grid>
      <Space mt={12} />
    </div>
  );
};
